<fieldset class="app-col">
  <legend>Attribute Properties</legend>
  <div class="form-group">
    <label class="control-label">Attribute Name:</label>
    <input (ngModelChange)="NotifyListeners()" #attrName_input [(ngModel)]="name" type="text" class='form-control' />
  </div>
  <div class="form-group" [class.hidden]="isSuppl">
    <label class="control-label">Type:</label>
    <div class="form-group-horizontal full-width">
      <div class="form-group full-width">
        <select (select)="TypeSelected()" [(ngModel)]="inputType" #inputType_sel class="form-select full-width">
          <option value="" selected>Select an input type</option>
          <option value="qty">Quantity input</option>
          <option [class.hidden]="!lengthBased" value="qtyperft">Quantity per foot</option>
          <option value="input">Text input</option>
          <option value="selector">Selector</option>
          <option value="checkbox">Checkbox</option>
        </select>
      </div>
      <div class="form-group fitted">
        <button (click)="EditNonSelOption()" [disabled]="isSelector" type="button"
          class="btn btn-sm row-btn btn-primary">
          <span class="fas fa-cog"></span>
        </button>
      </div>
    </div>
  </div>
  <div class="app-row form-group" [class.hidden]="!isSelector">
    <label class="full-width">Options</label>
    <div class="form-group-horizontal row-button stateful block-state req-selector no-gap">
      <button (click)="AddAttributeOption()" type="button" class="btn btn-sm btn-primary row-btn">
        <span class="fas fa-plus"></span>
      </button>
      <button (click)="DeleteAllOptions()" type="button" class="btn btn-sm btn-danger row-btn">
        <span class="fas fa-times"></span>
      </button>

    </div>
  </div>
  <div #optionRow class="form-group app-row" [class.hidden]="!hasOptions">
    <table class="options-table full-width">
      <thead [class.hidden]="isSuppl">
        <th [class.hidden]="!isSelector" title="Default Option">&nbsp;</th>
        <th scope="col">Option Label</th>
        <th>Materials USD</th>
        <th>Labor USD</th>
        <th></th>
      </thead>
      <tbody>
        <tr *ngFor="let option of options" [class.hidden]="!VerifyIncludeOption(option)">
          <td [class.hidden]="!isSelector"><input title="Use as default option" [(ngModel)]="defaultOption" type="radio"
              name="defaultOption" [value]="option.id">
          <td [title]="option.label" [innerText]="option.label"></td>
          <td [innerText]="GetOptionCost(option,'materials')"></td>
          <td [innerText]="GetOptionCost(option,'labor')"></td>
          <td class="actions-cell no-gap">
            <button [class.hidden]="!isSelector" (click)="EditAttributeOption(option)" type="button"
              class="btn-sm btn btn-primary row-btn">
              <span class="fas fa-cog"></span>
            </button>
            <button (click)="DeleteAttributeOption(option)" type="button" class="btn-sm btn btn-danger row-btn">
              <span class="fas fa-times"></span>
            </button>
          </td>

        </tr>
      </tbody>
    </table>
  </div>
  <div class="form-group" [class.hidden]="isSuppl">
    <label class="control-label">Display:</label>
    <div class="app-row displayWhen_options">
      <div class="inline ">
        <div class="form-check">
          <input id="displayAny_opt" class="form-check-input" #any_rbtn type="radio" name="criteria_rgrp" [value]="true"
            [(ngModel)]="displayAlways">
          <label for="displayAny_opt" class="form-check-label">always</label>
        </div>
        <div class="form-check full-width">
          <input id="displayWhen_opt" class="form-check" #condition_rbtn type="radio" name="criteria_rgrp"
            [value]="false" [(ngModel)]="displayAlways">
          <label for="displayWhen_opt" class="form-check-label">when condition</label>
        </div>
      </div>
      <div class="form-group inline no-gap" [class.hidden]="displayAlways===true">
        <button title="Add an available-when condition" (click)="AddCondition()" #whenCriteria_btn
          class="row-btn btn btn-primary btn-sm" type="button">
          <span class="fas fa-plus"></span>
        </button>
        <button title="Remove all available-when conditions" (click)="RemoveAllConditions()" type="button"
          class="row-btn btn btn-sm btn-danger"><span class="fas fa-times"></span></button>
      </div>
    </div>

  </div>
  <div [class.hidden]="displayAlways && isSuppl" class="form-group">
    <ng-container *ngIf="available.length > 0">
      <div class="attribute-condition app-row" *ngFor="let condition of available">
        <label [innerText]="GetConditionLabel(condition)"></label>
        <div class="inline">
          <button title="Edit this available-when condition" (click)="EditCondition(condition)" type="button"
            class="row-btn btn btn-sm btn-primary"><span class="fas fa-cog"></span></button>
          <button title="Remove this available-when condition" (click)="RemoveCondition(condition)" type="button"
            class="row-btn btn btn-sm btn-danger"><span class="fas fa-times"></span></button>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="app-row">
    <div class="form-group">
      <label class="col-xs-2 control-label">Calculation Method</label>
      <app-calculation-method-selector (methodSelectedChange)="HandleMethodChange($event)" [project]="project"
        [attribute]="attribute" [target]="calcMethodTarget" ></app-calculation-method-selector>
    </div>
  </div>


  <div class="form-group form-inline app-row stateful req-qty" [class.hidden]="isSuppl">
    <label class="control-label">Default Quantity</label>
    <input [(ngModel)]="defaultQty" class="form-control" type="number"  />
    <button type="button" class="btn btn-primary btn-sm" type="button">
      <span class="fas fa-cog"></span>
    </button>
  </div>
  <div class="form-group form-inline app-row stateful req-qtyperft" [class.hidden]="isSuppl">
    <label class="control-label">Default Quantity / ft</label>
    <input [(ngModel)]="defaultQtyPerFt" class="form-control" type="number"  />
    <button type="button" class="btn btn-default btn-sm" type="button">
      <span class="glyphicon glyphicon-cog"></span>
    </button>
  </div>
  <div class="form-group-horizonatal app-row stateful flex-state req-checkbox">
    <label class="form-label">Default State</label>
    <div class="form-check">
      <input class="form-check-input" type="checkbox" />
      <label class="form-check-label">default is {{defaultCheckLabel}}</label>
    </div>
    <button type="button" class="btn btn-default btn-sm" type="button">
      <span class="glyphicon glyphicon-cog"></span>
    </button>
  </div>
  <div class="form-group form-inline app-row stateful req-input" [class.hidden]="isSuppl">
    <label class="control-label">Default Text</label>
    <input class="form-control" type="text" #defaultText_input />
    <button type="button" data-dojo-attach-point="textDefaultCfg_btn" class="btn btn-default btn-sm" type="button">
      <span class="glyphicon glyphicon-cog"></span>
    </button>
  </div>
  <table class="suppl-defaults" *ngIf="isSuppl === true" role="layout" >
    <tr *ngFor="let supplInput of supplInputs">
      <td class="fitted no-wrap">
        <label class="control-label" [innerText]="supplInput.label"></label>
      </td>
      <td class="full-width">
        <input class="form-control" [(ngModel)]="supplDefaults[supplInput.id]" (keyup)="HandleSupplDefaultChange(supplInput.id,supplDefaults[supplInput.id])"
          type="text" />
      </td>
    </tr>
  </table>
</fieldset>
